import React, { useEffect, useState } from 'react'
import { useBookStore } from '../../provider/BookStore'

const PeriodePicker = ({ periode, periodeTitle, onPrev, onNext }) => {

  const bookState = useBookStore();
  const book = bookState.book;

  const [title,setTitle] = useState('Bulanan')

  useEffect(() => {
    setPeriode()
  }, []);

  const setPeriode = ()=>{
    const name = ['daily','weekly','monthly','yearly','custom'];
    const nama = ['Harian','Mingguan','Bulanan','Tahunan','Custom'];
    setTitle(nama[name.indexOf(periode)])
  }

  return (
    <div>
      <div className='is-clearfix m-2 mb-4'>
        <div className='is-pulled-left'>{title}</div>
        <div className='is-pulled-right'>
          <span className={book.display === 'custom' ? 'is-hidden'  : 'p-2 is-clickable'} onClick={onPrev}><i className="fa fa-chevron-left" aria-hidden="true"></i></span>
          <span className='has-text-weight-medium'>{periodeTitle}</span>
          <span className={book.display === 'custom' ? 'is-hidden'  : 'p-2 is-clickable'} onClick={onNext}><i className="fa fa-chevron-right" aria-hidden="true"></i></span>
        </div>
      </div>
    </div>
  )
}

export default PeriodePicker
